import { createFileRoute } from "@tanstack/react-router";
import { Transactions } from "@/components/Transactions";

function RouteComponent() {
  return <Transactions />;
}

export const Route = createFileRoute("/_authenticated/transactions/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
